// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Bermuda */
const BM = /^(?:441(?:[2378]\d|5[0-39]|9[02])\d{5})$/;

export default BM;
